function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckmark = function SvgCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "60pt",
    height: "60pt",
    viewBox: "0 0 208 208",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "surface251309"
  }, React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.039216%,80%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 180.53125 37.84375 L 166.1875 28.09375 C 162.21875 25.40625 156.78125 26.4375 154.125 30.375 L 83.8125 134.0625 L 51.5 101.75 C 48.125 98.375 42.625 98.375 39.25 101.75 L 26.96875 114.03125 C 23.59375 117.40625 23.59375 122.90625 26.96875 126.3125 L 76.65625 176 C 79.4375 178.78125 83.8125 180.90625 87.75 180.90625 C 91.6875 180.90625 95.65625 178.4375 98.21875 174.71875 L 182.84375 49.875 C 185.53125 45.9375 184.5 40.53125 180.53125 37.84375 Z M 180.53125 37.84375 "
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark.a69bcdd7.svg";
export { ForwardRef as ReactComponent };